'use strict';

var App = require('app');

var Address = Backbone.Model.extend({
    url: function () {
        return '/api/v1/devices/' + this.id + '/address';
    },
});

var API = {
    getEntity: function (deviceId) {
        var address = new Address({ id: deviceId });
        var defer = $.Deferred();

        address.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function () {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('address:model', function (deviceId) {
    return API.getEntity(deviceId);
});

module.exports = Address;
